var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('status-badge',{attrs:{"status-name":_vm.statusName,"type":_vm.colorVariant}})}
var staticRenderFns = []

export { render, staticRenderFns }